import { Text, type GridColDef } from '@shared/components';

import { formatDuration, formatMillisecondsToMinutesSeconds, formatTime } from './utils';

export interface ExamCourseTimeExtension {
  id: string;
  code: string;
  duration: number;
  endTime: Date;
  maxExtendableDurationInMs: number;
  isInProgress: boolean;
  isDisabled: boolean;
}

export const columns: GridColDef<ExamCourseTimeExtension>[] = [
  {
    field: 'code',
    headerName: 'หลักสูตร',
    sortable: false,
    flex: 1,
  },
  {
    field: 'duration',
    headerName: 'ระยะเวลาสอบ',
    sortable: false,
    flex: 1,
    valueFormatter: (params) => formatDuration(params.value),
  },
  {
    field: 'endTime',
    headerName: 'หมดเวลา',
    sortable: false,
    flex: 1,
    valueFormatter: (params) => formatTime(params.value),
  },
  {
    field: 'maxExtendableDurationInMs',
    headerName: 'เวลาที่ทดได้สูงสุด',
    sortable: false,
    flex: 1,
    renderCell: ({ value, row }) => {
      const parts = formatMillisecondsToMinutesSeconds(value);
      if (!parts) return null;

      if (row.isDisabled) {
        return (
          <Text variant='body1' component='span' color='inherit'>
            {parts.minutes}m {parts.seconds}s
          </Text>
        );
      }

      if (value === 0) {
        return (
          <Text variant='body1' component='span' color='text.disabled'>
            {parts.minutes}m {parts.seconds}s
          </Text>
        );
      }

      return (
        <Text variant='body1' component='span' color='text.secondary'>
          <Text variant='body1Semibold' component='span' color='text.primary'>
            {parts.minutes}
          </Text>
          m{' '}
          <Text variant='body1Semibold' component='span' color='text.primary'>
            {parts.seconds}
          </Text>
          s
        </Text>
      );
    },
  },
  {
    field: 'isInProgress',
    headerName: 'สถานะ',
    sortable: false,
    flex: 1,
    valueFormatter: (params) => (params.value ? 'In Progress' : 'Ended'),
  },
];
